import React from "react";

/**
 * SVG progress ring for the dashboard daily goal indicator.
 * Lightweight, accessible, and animates on prop change via CSS transitions.
 */
export default function DailyProgressRing({
  cards = 0,
  goal = 10,
  size = 72,
  stroke = 6,
  testId = "daily-progress-ring",
}) {
  const pct = goal > 0 ? Math.min(100, Math.round((cards / goal) * 100)) : 0;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct / 100);
  const complete = pct >= 100;

  return (
    <div className="inline-flex flex-col items-center" data-testid={testId}>
      <svg width={size} height={size} role="img" aria-label={`Daily goal: ${cards} of ${goal} cards`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--rule)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={complete ? "var(--success, #16a34a)" : "var(--ink)"}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{
            transform: "rotate(-90deg)",
            transformOrigin: "50% 50%",
            transition: "stroke-dashoffset 600ms ease",
          }}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          className="font-mono"
          style={{ fontSize: size * 0.22, fill: "var(--ink)" }}
        >
          {cards}/{goal}
        </text>
      </svg>
    </div>
  );
}
